import { render, staticRenderFns } from "./TransactionCategory.vue?vue&type=template&id=0e508f28&scoped=true"
import script from "./TransactionCategory.vue?vue&type=script&lang=js"
export * from "./TransactionCategory.vue?vue&type=script&lang=js"
import style0 from "./TransactionCategory.vue?vue&type=style&index=0&id=0e508f28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e508f28",
  null
  
)

export default component.exports